import { useLiveQuery } from "next-sanity/preview";
import { type ICS, csQuery } from "../queries";

export const useCSData = (data?: ICS) => {
  return useLiveQuery(data || null, csQuery);
};
